import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../api/axios";
interface Args {
  docId: number;
  recipientIds: number[];
}

interface Result {
  ok: true;
  sent: number; // cuántos OK
  failed: number; // cuántos KO
}

export function useSendDocument() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ docId, recipientIds }: Args): Promise<Result> => {
      const results = await Promise.allSettled(
        recipientIds.map((id) => api.post(`/documentos/${docId}/send`, { destinatarioId: id }))
      );

      const sent = results.filter((r) => r.status === "fulfilled").length;
      const failed = results.length - sent;

      if (failed) {
        // Lanza o maneja error parcial según UX que quieras
      }
      return { ok: true, sent, failed };
    },
    onSuccess: (_data, { docId }) => {
      qc.invalidateQueries({ queryKey: ["doc", docId] });
    },
  });
}
